











import { Component, Mixins, Prop } from 'vue-property-decorator'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'
import ShouninComment from '@/components/shounin/molecules/ShouninComment.vue'
import BaseComponent from '@/tcw/components/BaseComponent'

@Component({
  components: { ShouninComment }
})
export default class ShouninActionExecInfo extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected shouninInfo!: ApiGeneralSinglePayload
}
